export const register = {
  headline: "S'enregistrer",
  inputLabels: {
    userName: "Nom d'utilisateur",
    password: "Mot de passe",
    email: "Adresse E-mail",
    repeatPassword: "Répéter le mot de passe",
  },
  mainActions: {
    register: "S'enregistrer",
  },
  messages: {
    confirmationEmailSent:
      "Un e-mail vous a été envoyé. Veuillez suivre les instructions qui y figurent afin de compléter votre inscription.",
    registrationCodeInvalid:
      "Enregistrement échoué. Ce compte n'existe pas ou ne peut être activé pour le moment. Veuillez réessayer plus tard.",
    registrationSuccessful:
      '<h1 class="title is-2 has-text-grey">Merci de vous être enregistré. </h1><p class="title is-3 has-text-grey">Vous pouvez maintenant vous connecter avec votre nouveau compte.</p>',
    userNameInvalid:
      "Votre nom d'utilisateur ne peut pas contenir <strong>@</strong> ",
    userNameTooShort:
      "Votre nom d'utilisateur doit comporter au moins 4 caractères",
    userNameAlreadyExists:
      "Le nom d'utilisateur <span class='has-text-primary'>{username}</span> est déjà attribué. Veuillez en choisir un autre.",
    passwordMinLength: "8 charactères au minimum.",
    passwordMaxLength: "20 charactères au maximum."
  },
};
